import React from "react";
import Markdown from "markdown-to-jsx";
import styled from "styled-components";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

const Wrapper = styled.div`
  font-family: ${fonts.fontBauRegular};
  color: ${colors.black};
  font-size: 18px;
  line-height: 25px;
  font-weight: normal;
  margin-bottom: 32px;
  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
  }
`;

const Header = styled.h5`
  font-family: ${fonts.fontBauMedium};
  color: ${colors.black};
  font-size: 18px;
  line-height: 24px;
  text-transform: uppercase;
  font-weight: normal;
  margin-bottom: 16px;
  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
  }
`;

const List = styled.ul`
  padding-left: 1em;
  li {
    list-style-position: outside;
  }
`;

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 32px;
  th {
    display: none;
  }
  td {
    padding: 8px 4px;
    line-height: 17px;
    border-bottom: 1px solid ${colors.silverSoft};
  }
  td:first-child {
    font-family: ${fonts.fontInterstateUltraBlack};
    font-size: 11px;
    text-transform: uppercase;
  }
  td:last-child {
    font-family: ${fonts.fontBauRegular};
    font-size: 12px;
    text-align: right;
  }
`;

const Link = styled.a`
  text-decoration: underline;
  font-family: ${fonts.fontBauRegular};
  font-size: 18px;
  line-height: 25px;
`;

const BulletPoint = styled.li`
  margin-left: 5px;
`;

export interface MarkdownTextProps {
  markdownText: string;
}

const MarkdownText = ({ markdownText }: MarkdownTextProps) => (
  <Markdown
    options={{
      wrapper: Wrapper,
      overrides: {
        h1: {
          component: Header,
        },
        ul: {
          component: List,
        },
        table: {
          component: Table,
        },
        li: {
          component: BulletPoint,
        },
        a: {
          props: {
            target: "_blank",
            rel: "noopener",
          },
          component: Link,
        },
      },
    }}
  >
    {markdownText}
  </Markdown>
);

export default MarkdownText;
